export default __webpack_public_path__ + "4197608ae2ffb84f56a0c29adfc89136.png";